module.exports = __webpack_public_path__ + "static/1.2.C.7 Plan etaj-a8020afbcdc723132845b3533e519d0d.jpg";